import DocumentHeader from '@components/DocumentHeader';
import { Heading, Copy } from './styled';
import { Row, useMount } from '@simplywallst/ui-core';
import { Container } from './styled';
import Logo from '@assets/images/logo/warren-ice-cream.svg';
import GlobalStyle from '@/styled/styled.default';

export function OutdatedApp() {
  useMount(() => {
    if (window.TEST_RUNNER !== 'cypress') {
      setTimeout(() => {
        if (!window.location.href.includes('?invalidate')) {
          window.location.href = window.location.href.includes('?')
            ? `${window.location.href}&invalidate`
            : `${window.location.href}?invalidate`;
        } else {
          window.location.reload();
        }
      }, 1000);
    }
  });
  return (
    <Row height="100vh" width="100vw">
      <GlobalStyle />
      <DocumentHeader
        title={'You have an outdated version of Simply Wall St'}
        allowCrawlers={false}
        titleSuffix=""
      />
      <Container
        justifyContent="center"
        alignItem="center"
        alignContent="center"
        displayFlex
        column
      >
        <Logo />
        <Heading>You have an outdated version of Simply Wall St</Heading>
        <Copy>
          <span>The page will refresh in a moment</span>
        </Copy>
      </Container>
    </Row>
  );
}
